import { Autocomplete, MenuItem } from '@mui/material'
import { Control, Controller, FieldValues, Path } from 'react-hook-form'
import { AppTextField } from 'src/components/AppTextField'
import { sortByName } from 'src/utils'
import { LocalityOption } from './ApiAccessPage.action'

interface LocalityMultiSelectProps<T extends FieldValues> {
  control: Control<T>
  name: Path<T>
  options: LocalityOption[]
  label: string
  helperText?: string
  disabled?: boolean
}

export const LocalityMultiSelect = <T extends FieldValues>({
  control,
  name,
  options,
  label,
  helperText,
  disabled,
}: LocalityMultiSelectProps<T>) => {
  const sortedOptions = [...options].sort(sortByName)

  return (
    <Controller
      control={control}
      name={name}
      render={({ field }) => {
        const selectedIds = ((field.value as unknown as number[]) ?? []) as number[]

        return (
          <Autocomplete
            multiple
            disabled={disabled}
            value={sortedOptions.filter(o => selectedIds.includes(o.id))}
            onChange={(_, selected) => field.onChange((selected as LocalityOption[]).map(o => o.id))}
            options={sortedOptions}
            autoHighlight
            getOptionLabel={o => o.name}
            renderOption={(optionProps, o) => (
              <MenuItem {...optionProps} key={o.id} value={o.id}>
                {o.name}
              </MenuItem>
            )}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            renderInput={params => <AppTextField {...params} label={label} helperText={helperText} />}
          />
        )
      }}
    />
  )
}
